module.exports = __webpack_public_path__ + "static/ky-5814c5a94343cb013715ab05d3eac07b.svg";